import { Button } from "@mui/material";

export const CustomAlertDialog = ({alertmessage, handleCloseDialog, dispatchAction, actionName, performAction}) => {
  

    const handleClose=()=>{
        handleCloseDialog("close");
    };

    return (
        <div className="customalertdialog">
            <pre>{alertmessage}</pre>
            <div style={{
                width:"100%",
                display:"flex",
                alignItems: "flex-end",
                justifyContent: "flex-end"
            }}>

                <div className="flex-row2">
                    {performAction && 
                    <Button style={{color:"white"}} onClick={dispatchAction}>{actionName}</Button>
                    }  

                    <Button 
                    style={{color:"white"}}
                    onClick={()=>handleClose()}>
                        Ok
                    </Button>
                  
                </div>
          
            </div>
           
        </div>
      );
}